import type { ComponentProps } from "react"
import FieldDescriptionOrError from "./FieldDescriptionOrError"
import { Checkbox } from "@/ui/components/ui/checkbox"
import { Field, FieldContent, FieldLabel } from "@/ui/components/ui/field"

type Props = Omit<ComponentProps<typeof Checkbox>, "className"> &
  Pick<ComponentProps<typeof Field>, "className"> & {
    label: string
    helperText?: string
    error?: string
  }

export default function CheckboxField({
  name,
  label,
  helperText,
  error,
  className,
  ...props
}: Props) {
  return (
    <Field orientation="horizontal" className={className}>
      <Checkbox id={name} name={name} {...props} />
      <FieldContent>
        <FieldLabel htmlFor={name}>{label}</FieldLabel>
        <FieldDescriptionOrError description={helperText} error={error} />
      </FieldContent>
    </Field>
  )
}
